import { render } from "./m-questionnaire.vue?vue&type=template&id=cb1bdd72"
import script from "./m-questionnaire.vue?vue&type=script&lang=js"
export * from "./m-questionnaire.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__